// Generated static UI catalog. User-created content is intentionally not included.
module.exports = {
  "Duration": "Varighed",
  "Dusty rose": "St\u00f8vet rose",
  "e.g. \"Classify customer sentiment\" or \"Categorize support tickets into billing, technical, account, other\"": "f.eks. \"Klassificer kundef\u00f8lelse\" eller \"Kategoriser supportbilletter i fakturering, teknisk, konto, andet\"",
  "e.g. \"Write a personalized email using the @firstname and @email variables\" or \"Summarize customer feedback and extract action items\"": "f.eks. \"Skriv en personlig e-mail ved hj\u00e6lp af @fornavn og @email-variablerne\" eller \"Opsummer kundefeedback og udtr\u00e6k handlingspunkter\"",
  "e.g. API Key": "f.eks. API n\u00f8gle",
  "e.g. classify sentiment and return label + confidence": "f.eks. klassificere sentiment og returlabel + tillid",
  "E.g. Finance": "F.eks. Finans",
  "e.g. Keep responses concise and prefer reusable helper functions.": "f.eks. Hold svarene kortfattede og foretr\u00e6kker genanvendelige hj\u00e6lpefunktioner.",
  "e.g. Search for \"wireless headphones\" and open the first result (use @ for a variable)": "f.eks. S\u00f8g efter \"tr\u00e5dl\u00f8se hovedtelefoner\", og \u00e5bn det f\u00f8rste resultat (brug @ for en variabel)",
  "e.g. Send Email": "f.eks. Send e-mail",
  "e.g. Work Gmail": "f.eks. Arbejde med Gmail",
  "each item": "hver vare",
  "Edit": "Rediger",
  "Edit a node": "Rediger en knude",
  "Edit AI Instruction": "Rediger AI-instruktion",
  "Edit as JSON": "Rediger som JSON",
  "Edit tags": "Rediger tags",
  "Edit template": "Rediger skabelon",
  "Edit the staging version": "Rediger iscenes\u00e6ttelsesversionen",
  "Edit UI Page": "Rediger UI-side",
  "Edit value": "Rediger v\u00e6rdi",
  "Edit workflow tags": "Rediger workflow-tags",
  "edits your canvas": "redigerer dit l\u00e6rred",
  "Eksekverings-historik": "Eksekverings-historik",
  "Element selected": "Element valgt",
  "Email me when a run fails": "Send mig en e-mail, n\u00e5r et l\u00f8b mislykkes",
  "Email notifications": "E-mail notifikationer",
  "Empty array": "Tomt array",
  "empty boxes on the right": "tomme kasser til h\u00f8jre",
  "empty or missing": "tom eller mangler",
  "Empty page.": "Tom side.",
  "EN": "DA",
  "En betingelse pr. knude. Vaelg et felt, en operator og eventuelt en vaerdi. Flowet forgrener til ja- eller nej-anker.": "En betingelse pr. knude. Vaelg et felt, en operator og eventuelt en vaerdi. Flowet forgrener til ja- eller nej-anker.",
  "Enabled": "Aktiveret",
  "Enter a tag name.": "Indtast et tagnavn.",
  "Enter a valid http(s) URL": "Indtast en gyldig http(s) URL",
  "Enter a whole number of minutes (1 or more).": "Indtast et helt antal minutter (1 eller mere).",
  "Enter the inputs for this run.": "Indtast input for denne k\u00f8rsel.",
  "Entry point of the workflow": "Indgangspunkt for workflowet",
  "Error": "Fejl",
  "Error body": "Fejltekst",
  "Error responses": "Fejlsvar",
  "Error:": "Fejl:",
  "Error?": "Fejl?",
  "Errors": "Fejl",
  "Every minute": "Hvert minut",
  "Every request to the /v1 API must include your API key in the X-API-Key header. You can generate keys from the API Keys page in your dashboard.": "Hver anmodning til /v1 API skal inkludere din API-n\u00f8gle i X-API-Key-headeren. Du kan generere n\u00f8gler fra siden API Keys i dit dashboard.",
  "Example request": "Eksempel p\u00e5 anmodning",
  "Existing tags": "Eksisterende tags",
  "Expand editor": "Udvid editor",
  "Export": "Eksporter",
  "Failed to configure. Please try again.": "Kunne ikke konfigurere. Pr\u00f8v venligst igen.",
  "Failed to copy file URL.": "Filens URL kunne ikke kopieres.",
  "Failed to create API key.": "Kunne ikke oprette API-n\u00f8gle.",
  "Failed to create schedule.": "Kunne ikke oprette tidsplan.",
  "Failed to delete schedule.": "Kunne ikke slette tidsplanen.",
  "Failed to disconnect.": "Kunne ikke afbryde forbindelsen.",
  "Failed to load API keys.": "Kunne ikke indl\u00e6se API-n\u00f8gler.",
  "Failed to load files.": "Kunne ikke indl\u00e6se filer.",
  "Failed to load page": "Siden kunne ikke indl\u00e6ses",
  "Failed to load schedules.": "Kunne ikke indl\u00e6se tidsplaner.",
  "Failed to load template.": "Skabelonen kunne ikke indl\u00e6ses.",
  "Failed to load templates.": "Kunne ikke indl\u00e6se skabeloner.",
  "Failed to load users.": "Kunne ikke indl\u00e6se brugere.",
  "Failed to load waitlist.": "Kunne ikke indl\u00e6se venteliste.",
  "Failed to load.": "Kunne ikke indl\u00e6ses.",
  "Failed to revoke API key.": "API-n\u00f8gle kunne ikke tilbagekaldes.",
  "Failed to update schedule.": "Kunne ikke opdatere tidsplanen.",
  "False": "Falsk",
  "Fast": "Hurtigt",
  "Fast \u2014 lowest cost": "Hurtig - laveste pris",
  "Featured": "Udvalgte",
  "Featured (fills the store banner \u2014 only one)": "Fremh\u00e6vede (fylder butiksbanneret \u2013 kun \u00e9n)",
  "File manager collapsed": "Filh\u00e5ndtering er kollapset",
  "File Preview": "Forh\u00e5ndsvisning af fil",
  "Filter by URL\u2026": "Filtrer efter URL...",
  "Find fejl og lad AI foreslaa rettelser automatisk.": "Find fejl og lad AI foreslaa rettelser automatisk.",
  "Find it in Apify Console \u2192 Settings \u2192 API & Integrations. Used to run the actor.": "Find det i Apify Console \u2192 Indstillinger \u2192 API og integrationer. Bruges til at lede skuespilleren.",
  "Fix": "Fix",
  "Fix All (": "Ret alle (",
  "Fix any issue": "L\u00f8s ethvert problem",
  "Fix applied": "Fix anvendt",
  "Fix failed. Please try again.": "Rettelsen mislykkedes. Pr\u00f8v venligst igen.",
  "Fix succeeded!": "Rettelsen lykkedes!",
  "Fix with AskCode": "Ret med AskCode",
  "Fix:": "Ret:",
  "Fixed!": "Rettet!",
  "Fixing...": "Retter...",
  "Flow": "Flow",
  "Flow (Ref)": "Flow (ref.)",
  "Flow Preview": "Forh\u00e5ndsvisning af flow",
  "Flyt hele gruppen som en enhed. Nyttigt til at reorganisere store workflows.": "Flyt hele gruppen som en enhed. Nyttigt til at reorganisere butiks workflows.",
  "Flyt og kopier": "Flyt og kopier",
  "Fold en gruppe sammen for et rent overblik. Forbindelser til/fra gruppen bevares.": "Fold en gruppe sammen for et leje overblik. Forbindelser til/fra gruppen bevares.",
  "Fold sammen/ud": "Fold sammen/ud",
  "for review \u2014 your live version keeps serving installs until it\u2019s approved.": "til gennemgang \u2013 din liveversion bliver ved med at vise installationer, indtil den er godkendt.",
  "Forbrug": "Forbrug",
  "Forbrug pr. model": "Forbrug pr. model",
  "Forbrugsoversigt": "Forbrugsoversigt",
  "Forest green": "Skov gr\u00f8n",
  "Forgren dit workflow baseret pa data med betingelsesknuder.": "Forgren dit workflow baseret pa data med betingelsesknuder.",
  "Free \u00b7 installs in one click": "Gratis \u00b7 installeres med et enkelt klik",
  "Free \u00b7 sign in to install": "Gratis \u00b7 log ind for at installere",
  "Frequency": "Frekvens",
  "From input": "Fra input",
  "From previous steps": "Fra tidligere trin",
  "From workflow:": "Fra workflow:",
  "Full output": "Fuld output",
  "Fullscreen output": "Fuldsk\u00e6rms output",
  "Funktioner": "Funktioner",
  "Gem og del mellemresultater mellem knuder med typede workflow-variabler.": "Gem og del mellemresultater mellem knuder med typede workflow-variabler.",
  "General Guidance": "Generel vejledning",
  "Generate a preview first.": "Generer en forh\u00e5ndsvisning f\u00f8rst.",
  "Generate API keys to integrate Alleflow with third-party applications. Use the /v1 endpoints with your key in the X-API-Key header.": "Generer API-n\u00f8gler for at integrere Alleflow med tredjepartsapplikationer. Brug /v1-endepunkterne med din n\u00f8gle i X-API-Key-headeren.",
  "Generate key": "Generer n\u00f8gle",
  "Generate next flow with AI": "Generer n\u00e6ste flow med AI",
  "Generate now": "Generer nu",
  "Generated Configuration": "Genereret konfiguration",
  "Generating": "Genererer",
  "Generating workflow...": "Genererer workflow...",
  "Generating...": "Genererer...",
  "Generation failed": "Generation mislykkedes",
  "GET": "F\u00c5",
  "GET /v1/workflows": "GET /v1/workflows",
  "Get an email when a workflow run fails \u2014 credit or node-execution limit reached, per-minute rate hit, or a runtime error. Throttled so you never get flooded.": "F\u00e5 en e-mail, n\u00e5r en workflowk\u00f8rsel mislykkes - kredit- eller nodeudf\u00f8relsesgr\u00e6nse n\u00e5et, hastighed pr. minut eller en runtime-fejl. Droslet, s\u00e5 du aldrig bliver oversv\u00f8mmet.",
  "Get template": "Hent skabelon",
  "Get workflow": "F\u00e5 workflow",
  "Gmail": "Gmail",
  "Gmail, Jira, Tavily": "Gmail, Jira, Tavily",
  "Go to Alleflow": "G\u00e5 til Alleflow",
  "Goal": "M\u00e5l",
  "Google": "Google",
  "Gratis": "Gratis",
  "Group": "Gruppe",
  "Group selected nodes": "Grupp\u00e9r valgte knuder",
  "Guide-indhold": "Guide-indhold",
  "Har du brug for mere hjaelp?": "Har du brug for blot hjaelp?",
  "Have an account? Sign in": "Har du en konto? Log ind",
  "Header format": "Overskriftsformat",
  "Health Score": "Sundhedsscore",
  "Hent detaljer for et specifikt workflow inkl. knuder, forbindelser og variabler.": "Hent detaljer for et specifikt workflow inkl. knuder, forbindelser og variabler.",
  "Hent en liste over alle dine workflows.": "Hent en liste over alle dine workflows.",
  "Hide": "Skjul",
  "Hide run log": "Skjul k\u00f8rselslog",
  "History": "Historie",
  "Hourly": "Hver time",
  "How does this step work?": "Hvordan fungerer dette trin?",
  "How it works": "Hvordan det virker",
  "How to fix": "S\u00e5dan repareres",
  "How to run this workflow correctly: variables to set, sheets to create, accounts to connect\u2026": "S\u00e5dan k\u00f8res denne workflow korrekt: variabler der skal indstilles, ark der skal oprettes, konti der skal forbindes...",
  "Hurtig start": "Hurtig start",
  "Hvert workflow begynder med en Start-knude. Den er indgangspunktet og definerer eventuelle input-parametre som brugere skal udfylde ved korsel.": "Hvert workflow begynder med en Start-knude. Den er indgangspunktet og definerer eventuelle input-parametre som brugere skal udfylde ved korsel.",
  "I Got it": "Jeg forstod det",
  "I'll turn on Check Silent Errors and run the workflow so you can spot any issues right away.": "Jeg aktiverer Check Silent Errors og k\u00f8rer workflowet, s\u00e5 du kan opdage eventuelle problemer med det samme.",
  "Idea": "Id\u00e9",
  "If the key is missing or invalid you will receive:": "Hvis n\u00f8glen mangler eller er ugyldig, modtager du:",
  "Image read failed": "Billedl\u00e6sning mislykkedes",
  "images \u00b7 paste or click +": "billeder \u00b7 inds\u00e6t eller klik p\u00e5 +",
  "Import": "Importer",
  "In": "I",
  "In the opened tab: hover over an element, then choose its action (click, type, extract\u2026) from the balloon. The recording dock adds screenshot steps and finishes the recording. A node with just a URL and no steps simply opens the page.": "P\u00e5 den \u00e5bnede fane: Hold mark\u00f8ren over et element, og v\u00e6lg derefter dets handling (klik, skriv, udtr\u00e6k...) fra ballonen. Optagedocken tilf\u00f8jer sk\u00e6rmbilledetrin og afslutter optagelsen. En knude med kun en URL og ingen trin \u00e5bner blot siden.",
  "Indhold": "Indhold",
  "Indl\u00e6ser\u2026": "Indl\u00e6ser\u2026",
  "Info": "Info",
  "Ingen k\u00f8rsler i denne periode endnu.": "Ingen k\u00f8rsler i denne periode endnu.",
  "Initial value": "Startv\u00e6rdi",
  "Input": "Input",
  "Input Tokens": "Indtast tokens",
  "Insert": "Inds\u00e6t",
  "Insert a node in between": "Inds\u00e6t en knude imellem",
  "Insert node here": "Inds\u00e6t knude her",
  "Insert node on this connection": "Inds\u00e6t knude p\u00e5 denne forbindelse",
  "Inspect the workflow and fill these fields with AI": "Unders\u00f8g workflowet og udfyld disse felter med AI",
  "Inspecting workflow\u2026": "Inspicerer workflow...",
  "Install failed.": "Installationen mislykkedes.",
  "Install template": "Installer skabelon",
  "Installing\u2026": "Installerer...",
  "Instruction": "Instruktion",
  "Integer": "Heltal",
  "Integrations": "Integrationer",
  "Intet kreditkort p\u00e5kr\u00e6vet. Fuld adgang under beta.": "Intet kreditkort p\u00e5kr\u00e6vet. Fuld adgang under beta.",
  "Introduction": "Introduktion",
  "Invalid file name.": "Ugyldigt filnavn.",
  "Invalid or missing API key.": "Ugyldig eller manglende API-n\u00f8gle.",
  "isn\u2019t connected yet.": "er ikke forbundet endnu.",
  "Issue": "Udstedelse",
  "Issues (": "Problemer (",
  "items]": "genstande]",
  "Iter over arrays og gentag delflows.": "Iter over arrays og gentag delflows.",
  "Iterate over a list": "Gentag over en liste",
  "JavaScript Code": "JavaScript kode",
  "JSON": "JSON",
  "just now": "lige nu",
  "Keep editing your draft \u2014 saving will overwrite the other version": "Forts\u00e6t med at redigere din kladde \u2013 lagring overskriver den anden version",
  "Keep my draft": "Behold mit udkast",
  "Keep the latest value for the next run": "Behold den seneste v\u00e6rdi til n\u00e6ste k\u00f8rsel",
  "Keep working": "Forts\u00e6t med at arbejde",
  "keeps serving installs in the meantime.": "forts\u00e6tter med at vise installationer i mellemtiden.",
  "Key": "N\u00f8gle",
  "Key name (e.g. \"My Integration\")": "N\u00f8glenavn (f.eks. \"Min integration\")",
  "keys}": "n\u00f8gler}",
  "Klar til at bygge dit forste workflow?": "Klar til at bygge dit forste workflow?",
  "Klik pa en knude for at abne dens indstillinger. Alt efter typen kan du skrive JavaScript-kode, definere betingelser, saette variabler eller konfigurere AI-klassificering.": "Klik pa en knude for at abne dens indstillinger. Alt efter typen kan du skrive JavaScript-kode, definere betingelser, saette variabler eller konfigurere AI-klassificering.",
  "Klik pa Start-knuden og tiloj hyperparametre. Hver parameter har et navn, en type og en valgfri beskrivelse.": "Klik pa Start-knuden og tiloj hyperparametre. Hver parameter har et navn, en type og en valgfri beskrivelse.",
  "Knowledge Items": "Vidensartikler",
  "Knude-eksekveringer": "Knude-eksekveringer",
  "Knuden returnerer { classification: \"label\", confidences: { label1: 0.9, label2: 0.1 } } \u2014 bade det valgte label og scores for alle labels.": "Knuden returnerer { classification: \"label\", confidences: { label1: 0.9, label2: 0.1 } } \u2014 bade det valgte label og scores for alle labels.",
  "Kom i gang": "Kom i gang",
  "Kombiner flere betingelser med AND/OR logik. Du kan gruppere op til 2 niveauer af betingelser for kompleks beslutningslogik.": "Kombiner flere betingelser med AND/OR logik. Du kan gruppere op til 2 niveauer af betingelser for kompleks beslutningslogik.",
  "Konto": "Konto",
  "Kreditter": "Kreditter",
  "Kunne ikke hente data": "Kunne ikke hente data",
  "Label name...": "Etiketnavn...",
  "Lad en LLM klassificere data og forgrene workflowet automatisk.": "Lad en LLM klassificere data og forgrene workflowet automatisk.",
  "Laes en variabel i kode": "Laes en variabel i kode",
  "Laes og skriv variabler i kode": "Laes og skriv variabler i kode",
  "Language": "Sprog",
  "Last event": "Sidste begivenhed",
  "Last Run": "Sidste l\u00f8b",
  "Last used": "Sidst brugt",
  "Leave blank to use the natural randomized typing speed": "Lad st\u00e5 tomt for at bruge den naturlige randomiserede skrivehastighed",
  "Let AI complete a task from browser screenshots": "Lad AI udf\u00f8re en opgave fra browsersk\u00e6rmbilleder",
  "Light Mode": "Lys tilstand",
  "Lime": "Lime",
  "List": "Liste",
  "List workflows": "Liste over workflows",
  "Listed nodes & connections": "Listede knuder og forbindelser",
  "Listen": "H\u00f8r her",
  "Listen mode": "Lyttetilstand",
  "Listening": "At lytte"
};
